import { render } from "./welcome-new.vue?vue&type=template&id=674b296d"
import script from "./welcome-new.vue?vue&type=script&lang=js"
export * from "./welcome-new.vue?vue&type=script&lang=js"

import "./welcome-new.vue?vue&type=style&index=0&id=674b296d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__